import React from "react";
import "./ActionButtons.scss";
import { IconButton } from "@SeemplicityDev/shared";

interface ActionButtonsProps {
  disableSave?: boolean;
  disableSaveAs?: boolean;
  showDelete?: boolean;
  disableDelete?: boolean;
  onDelete?: () => void;
  disableCancelEdit?: boolean;
  // onSave is used only as a truthy guard for conditional rendering (the save
  // button is type="submit" with no onClick), so the consumer passes a boolean.
  onSave?: boolean;
  onSaveAs?: (() => void) | null;
  onCancelHandler?: (() => void) | null;
  showEditButton?: boolean;
  onEditHandler?: () => void;
  location?: string;
  isSaving?: boolean;
  saveTooltipContent?: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  disableSave,
  disableSaveAs,
  showDelete,
  disableDelete,
  onDelete,
  disableCancelEdit,
  onSave,
  onSaveAs,
  onCancelHandler,
  showEditButton,
  onEditHandler,
  location,
  isSaving,
  saveTooltipContent,
}) => {
  return (
    <div className={"action-buttons-wrap"}>
      {/* cancel edit */}
      {onCancelHandler && (
        <IconButton
          isIcon={"seem-icon-x-small"}
          type={"button"}
          data-testid={`filter-cancel-edit-${location}`}
          label={"Cancel"}
          disabled={disableCancelEdit}
          onClick={onCancelHandler}
          withTooltip={{ content: "Cancel", place: "bottom" }}
        />
      )}
      {/*save as */}
      {onSaveAs && (
        <IconButton
          data-testid={`filter-save-as-${location}`}
          type={"button"}
          isIcon={"seem-icon-save-as"}
          disabled={disableSaveAs}
          onClick={onSaveAs}
          withTooltip={{
            content: saveTooltipContent || "Save As",
            place: "bottom",
          }}
        />
      )}
      {/* save */}
      {onSave && (
        <IconButton
          data-testid={`filter-save-${location}`}
          type={"submit"}
          isIcon={isSaving ? "seem-icon-spinner" : "seem-icon-save"}
          disabled={disableSave}
          className={isSaving ? "spinner" : ""}
          withTooltip={{
            content: saveTooltipContent || "Save",
            place: "bottom",
          }}
        />
      )}
      {/* delete */}
      {showDelete && (
        <IconButton
          data-testid={`remove-filter-field-${location}`}
          type={"button"}
          isIcon={"seem-icon-bin"}
          disabled={disableDelete}
          onClick={onDelete}
          withTooltip={{ content: "Delete", place: "bottom" }}
        />
      )}
      {showEditButton && (
        <IconButton
          type={"button"}
          data-testid={`edit-filter`}
          isIcon={"seem-icon-edit"}
          size={"xs"}
          withTooltip={{
            content: "Edit filter",
          }}
          onClick={onEditHandler}
          data-analytics-event={"user_click"}
          data-analytics-props={'{"name": "edit_filter_btn"}'}
        />
      )}
    </div>
  );
};

export default ActionButtons;
